/** Auto-generated English → admin.ui.* keys — do not edit by hand.
 * Regenerate: node frontend/_generate_ui_catalog.cjs
 */
export const ADMIN_PANEL_UI_MAP: Record<string, string> = {
  "— Any / All —": "admin.ui.any_all",
  "— no change —": "admin.ui.no_change",
  "— No options —": "admin.ui.no_options",
  "— None —": "admin.ui.none",
  "— Select —": "admin.ui.select",
  "— Select merchant —": "admin.ui.select_merchant",
  "— Select plan —": "admin.ui.select_plan",
  "— Select zone —": "admin.ui.select_zone",
  "0 = no limit": "admin.ui.0_no_limit",
  "1. Consultation Setup": "admin.ui.1_consultation_setup",
  "1. Event Booking": "admin.ui.1_event_booking",
  "1. Fleet & Branch": "admin.ui.1_fleet_branch",
  "1. Fleet & Depots": "admin.ui.1_fleet_depots",
  "1. Geography": "admin.ui.1_geography",
  "1. Home Banners": "admin.ui.1_home_banners",
  "1. Outstation Vehicles": "admin.ui.1_outstation_vehicles",
  "1. Promos & Coupons": "admin.ui.1_promos_coupons",
  "1. Restaurant & Branch": "admin.ui.1_restaurant_branch",
  "1. Service Catalog": "admin.ui.1_service_catalog",
  "1. Store & Types": "admin.ui.1_store_types",
  "10-digit mobile number": "admin.ui.10_digit_mobile_number",
  "17 Food Add masters → 6-tab wizard. Swiggy-like order pipeline with OTP delivery.": "admin.ui.17_food_add_masters_6_tab_wizard_swiggy_like_order_pipeline_with_otp_delivery",
  "2. Classification": "admin.ui.2_classification",
  "2. Locale & Currency": "admin.ui.2_locale_currency",
  "2. Outstation Pricing": "admin.ui.2_outstation_pricing",
  "2. Rental Vehicles": "admin.ui.2_rental_vehicles",
  "2. Vehicle Taxonomy": "admin.ui.2_vehicle_taxonomy",
  "2. Warehouses & Variants": "admin.ui.2_warehouses_variants",
  "24-hour live pulse": "admin.ui.24_hour_live_pulse",
  "3. Attributes & Variants": "admin.ui.3_attributes_variants",
  "3. Availability": "admin.ui.3_availability",
  "3. Images & Availability": "admin.ui.3_images_availability",
  "3. Operations": "admin.ui.3_operations",
  "3. Rental Packages": "admin.ui.3_rental_packages",
  "3. Ride Attributes": "admin.ui.3_ride_attributes",
  "30-day service trends": "admin.ui.30_day_service_trends",
  "4-tab Grocery Add wizard — masters drive category, brand, variant, tax, and images.": "admin.ui.4_tab_grocery_add_wizard_masters_drive_category_brand_variant_tax_and_images",
  "4. Addons": "admin.ui.4_addons",
  "4. Availability & Media": "admin.ui.4_availability_media",
  "4. Grocery Add": "admin.ui.4_grocery_add",
  "4. Payments": "admin.ui.4_payments",
  "5. Delivery Operations": "admin.ui.5_delivery_operations",
  "5. Driver Payout Models": "admin.ui.5_driver_payout_models",
  "5. Partners & Payout": "admin.ui.5_partners_payout",
  "5. Tax, Unit, Kitchen": "admin.ui.5_tax_unit_kitchen",
  "6-tab Food Add flow — variants, addons, tax, availability. No inventory or discounts.": "admin.ui.6_tab_food_add_flow_variants_addons_tax_availability_no_inventory_or_discounts",
  "6-tab wizard — all 12 grocery masters drive category, supply, availability, and images.": "admin.ui.6_tab_wizard_all_12_grocery_masters_drive_category_supply_availability_and_image",
  "6-tab wizard — catalog only": "admin.ui.6_tab_wizard_catalog_only",
  "6-tab wizard — full catalog flow": "admin.ui.6_tab_wizard_full_catalog_flow",
  "6. Availability & Images": "admin.ui.6_availability_images",
  "6. Customer App": "admin.ui.6_customer_app",
  "6. Mobile Banners": "admin.ui.6_mobile_banners",
  "7-tab professional flow — only food-catalog masters (no inventory, recipe, or discount)": "admin.ui.7_tab_professional_flow_only_food_catalog_masters_no_inventory_recipe_or_discoun",
  "7. Admin Operations": "admin.ui.7_admin_operations",
  "7. Food Add": "admin.ui.7_food_add",
  "8. Mobile Banners": "admin.ui.8_mobile_banners",
  "Accept / Reject": "admin.ui.accept_reject",
  "Accept incoming restaurant orders, mark ready, and track delivery": "admin.ui.accept_incoming_restaurant_orders_mark_ready_and_track_delivery",
  "Accept Order": "admin.ui.accept_order",
  "Accept orders, track kitchen-to-delivery workflow, and collect ratings.": "admin.ui.accept_orders_track_kitchen_to_delivery_workflow_and_collect_ratings",
  "Accept Ride": "admin.ui.accept_ride",
  "Accept store orders, pack items, mark ready, and track delivery": "admin.ui.accept_store_orders_pack_items_mark_ready_and_track_delivery",
  "Accepted": "admin.ui.accepted",
  "Access & Roles": "admin.ui.access_roles",
  "Account Code": "admin.ui.account_code",
  "Accounts": "admin.ui.accounts",
  "Acknowledged": "admin.ui.acknowledged",
  "Action": "admin.ui.action",
  "Action items": "admin.ui.action_items",
  "Actions": "admin.ui.actions",
  "Activate": "admin.ui.activate",
  "Active": "admin.ui.active",
  "Active — available for purchase": "admin.ui.active_available_for_purchase",
  "Active — can be assigned to tenants": "admin.ui.active_can_be_assigned_to_tenants",
  "Active account": "admin.ui.active_account",
  "Active Alerts": "admin.ui.active_alerts",
  "Active food orders": "admin.ui.active_food_orders",
  "Active grocery orders": "admin.ui.active_grocery_orders",
  "Active Listing": "admin.ui.active_listing",
  "Active Rides": "admin.ui.active_rides",
  "Active Subs": "admin.ui.active_subs",
  "Actual": "admin.ui.actual",
  "Add": "admin.ui.add",
  "Add (+)": "admin.ui.add_2",
  "Add customer": "admin.ui.add_customer",
  "Add Grocery Product": "admin.ui.add_grocery_product",
  "Add Menu Item": "admin.ui.add_menu_item",
  "Add packages with per-vehicle pricing. Status toggle and delete guards match Caby behavior.": "admin.ui.add_packages_with_per_vehicle_pricing_status_toggle_and_delete_guards_match_caby",
  "Add tier": "admin.ui.add_tier",
  "Add to cart": "admin.ui.add_to_cart",
  "Add to Cart": "admin.ui.add_to_cart_2",
  "Addon": "admin.ui.addon",
  "Addon Group": "admin.ui.addon_group",
  "Addon Groups": "admin.ui.addon_groups",
  "Addon name": "admin.ui.addon_name",
  "Address": "admin.ui.address",
  "Address / Notes": "admin.ui.address_notes",
  "Address & Notes": "admin.ui.address_notes_2",
  "Address Fields": "admin.ui.address_fields",
  "Admin": "admin.ui.admin",
  "Admin & Staff": "admin.ui.admin_staff",
  "Admin & Staff — Full Function Reference": "admin.ui.admin_staff_full_function_reference",
  "Admin Commission Type": "admin.ui.admin_commission_type",
  "Admin Commission Value": "admin.ui.admin_commission_value",
  "Admin email": "admin.ui.admin_email",
  "Admin first name": "admin.ui.admin_first_name",
  "Admin functions — not in Service Add wizard": "admin.ui.admin_functions_not_in_service_add_wizard",
  "Admin functions — store, slot, and dispatch controls": "admin.ui.admin_functions_store_slot_and_dispatch_controls",
  "Admin functions — Swiggy-like platform controls": "admin.ui.admin_functions_swiggy_like_platform_controls",
  "Admin Hub Tabs — Food / Delivery Service": "admin.ui.admin_hub_tabs_food_delivery_service",
  "Admin Hub Tabs — Transport Service": "admin.ui.admin_hub_tabs_transport_service",
  "Admin last name": "admin.ui.admin_last_name",
  "Admin Panel": "admin.ui.admin_panel",
  "Admin password": "admin.ui.admin_password",
  "Admin phone": "admin.ui.admin_phone",
  "Admin user": "admin.ui.admin_user",
  "Admin verification required": "admin.ui.admin_verification_required",
  "Administration": "admin.ui.administration",
  "AED — UAE Dirham": "admin.ui.aed_uae_dirham",
  "Aggregate": "admin.ui.aggregate",
  "All": "admin.ui.all",
  "All History": "admin.ui.all_history",
  "All hubs": "admin.ui.all_hubs",
  "All outstation services": "admin.ui.all_outstation_services",
  "All partner types": "admin.ui.all_partner_types",
  "All pending": "admin.ui.all_pending",
  "All rental services": "admin.ui.all_rental_services",
  "All review list of drivers": "admin.ui.all_review_list_of_drivers",
  "All Rides": "admin.ui.all_rides",
  "All services": "admin.ui.all_services",
  "All Services": "admin.ui.all_services_2",
  "All statuses": "admin.ui.all_statuses",
  "All store operations — food, grocery, menu, inventory, and payouts": "admin.ui.all_store_operations_food_grocery_menu_inventory_and_payouts",
  "All time": "admin.ui.all_time",
  "All types": "admin.ui.all_types",
  "All users": "admin.ui.all_users",
  "All zones": "admin.ui.all_zones",
  "Allow driver counter-offers": "admin.ui.allow_driver_counter_offers",
  "Allow substitution if out of stock": "admin.ui.allow_substitution_if_out_of_stock",
  "America/Los_Angeles (PST)": "admin.ui.america_los_angeles_pst",
  "America/New_York (EST)": "admin.ui.america_new_york_est",
  "Amount": "admin.ui.amount",
  "Amount / Subtotal": "admin.ui.amount_subtotal",
  "Analytics + Order Reports": "admin.ui.analytics_order_reports",
  "Analytics command center": "admin.ui.analytics_command_center",
  "App area": "admin.ui.app_area",
  "Applied to employee bookings billed to this account": "admin.ui.applied_to_employee_bookings_billed_to_this_account",
  "Apply from masters": "admin.ui.apply_from_masters",
  "Apply to all": "admin.ui.apply_to_all",
  "Approval": "admin.ui.approval",
  "Approval & Revenue": "admin.ui.approval_revenue",
  "Approval Status": "admin.ui.approval_status",
  "Approve": "admin.ui.approve",
  "Approved": "admin.ui.approved",
  "Arrive at Customer": "admin.ui.arrive_at_customer",
  "Arrive at Restaurant": "admin.ui.arrive_at_restaurant",
  "Arrive at Store": "admin.ui.arrive_at_store",
  "Asia/Dubai (GST)": "admin.ui.asia_dubai_gst",
  "Asia/Kolkata (IST)": "admin.ui.asia_kolkata_ist",
  "Asia/Singapore (SGT)": "admin.ui.asia_singapore_sgt",
  "Asia/Tokyo (JST)": "admin.ui.asia_tokyo_jst",
  "Assign & Notify": "admin.ui.assign_notify",
  "Assign Driver": "admin.ui.assign_driver",
  "Assign Partner": "admin.ui.assign_partner",
  "Assigned Roles": "admin.ui.assigned_roles",
  "Attribute Values": "admin.ui.attribute_values",
  "AUD — Australian Dollar": "admin.ui.aud_australian_dollar",
  "Audience": "admin.ui.audience",
  "Audio": "admin.ui.audio",
  "Australia": "admin.ui.australia",
  "Australia/Sydney (AEST)": "admin.ui.australia_sydney_aest",
  "Auto-accept lowest bid when window expires": "admin.ui.auto_accept_lowest_bid_when_window_expires",
  "Auto-accept ON": "admin.ui.auto_accept_on",
  "Auto-assign nearest driver": "admin.ui.auto_assign_nearest_driver",
  "Auto-dispatch delivery partner": "admin.ui.auto_dispatch_delivery_partner",
  "Auto-Dispatch Partners": "admin.ui.auto_dispatch_partners",
  "Auto-renew at end of billing cycle": "admin.ui.auto_renew_at_end_of_billing_cycle",
  "Auto-set from user type": "admin.ui.auto_set_from_user_type",
  "Auto-verify on create (skip document approval)": "admin.ui.auto_verify_on_create_skip_document_approval",
  "Auto-verify partner (skip document approval queue)": "admin.ui.auto_verify_partner_skip_document_approval_queue",
  "Availability Schedule": "admin.ui.availability_schedule",
  "Availability schedules": "admin.ui.availability_schedules",
  "Availability Schedules": "admin.ui.availability_schedules_2",
  "Available": "admin.ui.available",
  "Avg Pick Time (mins)": "admin.ui.avg_pick_time_mins",
  "Awaiting approval": "admin.ui.awaiting_approval",
  "Badge label": "admin.ui.badge_label",
  "Balance": "admin.ui.balance",
  "Banks": "admin.ui.banks",
  "Base": "admin.ui.base",
  "Base ₹": "admin.ui.base_2",
  "Base Amount (₹)": "admin.ui.base_amount",
  "Base Distance": "admin.ui.base_distance",
  "Base Fare": "admin.ui.base_fare",
  "Base KM (included)": "admin.ui.base_km_included",
  "Base Price": "admin.ui.base_price",
  "Base Price (₹)": "admin.ui.base_price_2",
  "Basic details": "admin.ui.basic_details",
  "Basic Details": "admin.ui.basic_details_2",
  "Basic info": "admin.ui.basic_info",
  "Batch delivery (multiple orders same route)": "admin.ui.batch_delivery_multiple_orders_same_route",
  "Benefits & publish": "admin.ui.benefits_publish",
  "Bestseller": "admin.ui.bestseller",
  "Bidding": "admin.ui.bidding",
  "Bidding Max": "admin.ui.bidding_max",
  "Bidding Min": "admin.ui.bidding_min",
  "Bidding zone": "admin.ui.bidding_zone",
  "Bike Rental Setup": "admin.ui.bike_rental_setup",
  "Billing cycle": "admin.ui.billing_cycle",
  "Billing email": "admin.ui.billing_email",
  "Billing Email": "admin.ui.billing_email_2",
  "Billing phone": "admin.ui.billing_phone",
  "Blocked": "admin.ui.blocked",
  "Blocked by admin": "admin.ui.blocked_by_admin",
  "Body": "admin.ui.body",
  "Bonus": "admin.ui.bonus",
  "Bonus amount (₹)": "admin.ui.bonus_amount",
  "Book a Ride": "admin.ui.book_a_ride",
  "Book Ride": "admin.ui.book_ride",
  "Book rides, advance workflow stages, assign drivers, and rate completed trips.": "admin.ui.book_rides_advance_workflow_stages_assign_drivers_and_rate_completed_trips",
  "Booking For": "admin.ui.booking_for",
  "Booking Setup Guide": "admin.ui.booking_setup_guide",
  "Booking Summary": "admin.ui.booking_summary",
  "Both": "admin.ui.both",
  "Branch": "admin.ui.branch",
  "Branch (optional)": "admin.ui.branch_optional",
  "Branch Master": "admin.ui.branch_master",
  "Brand": "admin.ui.brand",
  "Brand, model, variant, color, fuel": "admin.ui.brand_model_variant_color_fuel",
  "Branding": "admin.ui.branding",
  "Brands": "admin.ui.brands",
  "Browse Restaurants": "admin.ui.browse_restaurants",
  "Browse Stores": "admin.ui.browse_stores",
  "Business": "admin.ui.business",
  "Business / Store Name": "admin.ui.business_store_name",
  "Business Type": "admin.ui.business_type",
  "Business, vehicle, referral, and commission settings": "admin.ui.business_vehicle_referral_and_commission_settings",
  "Busy Drivers": "admin.ui.busy_drivers",
  "CAD — Canadian Dollar": "admin.ui.cad_canadian_dollar",
  "Calories (kcal)": "admin.ui.calories_kcal",
  "Campaign": "admin.ui.campaign",
  "Canada": "admin.ui.canada",
  "Cancel": "admin.ui.cancel",
  "Cancel rate": "admin.ui.cancel_rate",
  "Cancel Reasons + Penalties": "admin.ui.cancel_reasons_penalties",
  "Cancellation + Refund Policy": "admin.ui.cancellation_refund_policy",
  "Cancellation Fee (after accept)": "admin.ui.cancellation_fee_after_accept",
  "Cancellation Fee (after arrive)": "admin.ui.cancellation_fee_after_arrive",
  "Cancellation Policies": "admin.ui.cancellation_policies",
  "Cancellation Reasons": "admin.ui.cancellation_reasons",
  "Cancelled": "admin.ui.cancelled",
  "Capacity (seats)": "admin.ui.capacity_seats",
  "Car Rental Setup": "admin.ui.car_rental_setup",
  "Carbohydrates (g)": "admin.ui.carbohydrates_g",
  "Card": "admin.ui.card",
  "Card / Online": "admin.ui.card_online",
  "Carousel banners on Food, Grocery, and Transport tabs in the mobile app.": "admin.ui.carousel_banners_on_food_grocery_and_transport_tabs_in_the_mobile_app",
  "Carousel images on Food, Grocery, and Taxi tabs in the customer app": "admin.ui.carousel_images_on_food_grocery_and_taxi_tabs_in_the_customer_app",
  "Cart Checkout": "admin.ui.cart_checkout",
  "Cash": "admin.ui.cash",
  "Cashfree": "admin.ui.cashfree",
  "Catalog / Stores": "admin.ui.catalog_stores",
  "Categories": "admin.ui.categories",
  "Categories, skills, and pricing templates": "admin.ui.categories_skills_and_pricing_templates",
  "Category": "admin.ui.category",
  "Category *": "admin.ui.category_2",
  "Category, sub-category, cuisine, dietary, tags": "admin.ui.category_sub_category_cuisine_dietary_tags",
  "Certificates": "admin.ui.certificates",
  "Change": "admin.ui.change",
  "Change Status": "admin.ui.change_status",
  "Channel": "admin.ui.channel",
  "Chat": "admin.ui.chat",
  "Checkout": "admin.ui.checkout",
  "City": "admin.ui.city",
  "City or area name": "admin.ui.city_or_area_name",
  "City Required": "admin.ui.city_required",
  "City-to-city route packages with driver allowance, per-km rate, and round-trip multiplier.": "admin.ui.city_to_city_route_packages_with_driver_allowance_per_km_rate_and_round_trip_mul",
  "Clear subscription filter": "admin.ui.clear_subscription_filter",
  "Click at least 3 corners on the map, then tap Done": "admin.ui.click_at_least_3_corners_on_the_map_then_tap_done",
  "Client Admin": "admin.ui.client_admin",
  "Client Admin (within tenant)": "admin.ui.client_admin_within_tenant",
  "Close": "admin.ui.close",
  "Close catalog": "admin.ui.close_catalog",
  "Close flow guide": "admin.ui.close_flow_guide",
  "Closed": "admin.ui.closed",
  "Code": "admin.ui.code",
  "Code (auto-generated if blank)": "admin.ui.code_auto_generated_if_blank",
  "Code, name, and description": "admin.ui.code_name_and_description",
  "Code, zone, and partner type": "admin.ui.code_zone_and_partner_type",
  "Comments": "admin.ui.comments",
  "Commission": "admin.ui.commission",
  "Commission (zone %)": "admin.ui.commission_zone",
  "Commission %": "admin.ui.commission_2",
  "Commission + Settlements": "admin.ui.commission_settlements",
  "Commission based": "admin.ui.commission_based",
  "Commission rate (%)": "admin.ui.commission_rate",
  "Commission Rates": "admin.ui.commission_rates",
  "Commission Settlements": "admin.ui.commission_settlements_2",
  "Commission structure (% or fixed per order)": "admin.ui.commission_structure_or_fixed_per_order",
  "Commission structure per order": "admin.ui.commission_structure_per_order",
  "Commission Type": "admin.ui.commission_type",
  "Commission Value": "admin.ui.commission_value",
  "Commission vs subscription per zone": "admin.ui.commission_vs_subscription_per_zone",
  "Company": "admin.ui.company",
  "Company name": "admin.ui.company_name",
  "Complete": "admin.ui.complete",
  "Complete capability breakdown — roles, permissions, and hub tab actions.": "admin.ui.complete_capability_breakdown_roles_permissions_and_hub_tab_actions",
  "Complete capability breakdown for Super Admin, Client Admin, and Employee roles": "admin.ui.complete_capability_breakdown_for_super_admin_client_admin_and_employee_roles",
  "Complete Trip": "admin.ui.complete_trip",
  "Completed": "admin.ui.completed",
  "Completed vs cancelled": "admin.ui.completed_vs_cancelled",
  "Completed vs cancelled trends and payment channel breakdown": "admin.ui.completed_vs_cancelled_trends_and_payment_channel_breakdown",
  "Completion": "admin.ui.completion",
  "Configurable options → generated variants": "admin.ui.configurable_options_generated_variants",
  "Configurable service options": "admin.ui.configurable_service_options",
  "Configuration": "admin.ui.configuration",
  "Configure drag-and-drop KPI dashboards per role — driver, merchant, provider, admin, and more.": "admin.ui.configure_drag_and_drop_kpi_dashboards_per_role_driver_merchant_provider_admin_a",
  "Configure groups and document types partners must upload": "admin.ui.configure_groups_and_document_types_partners_must_upload",
  "Configure in Inventory, Purchase, Marketing modules": "admin.ui.configure_in_inventory_purchase_marketing_modules",
  "Configure platform services": "admin.ui.configure_platform_services",
  "Configure ride modes, vehicle types, and pricing masters.": "admin.ui.configure_ride_modes_vehicle_types_and_pricing_masters",
  "Configure RIDE NOW and RIDE LATER pricing per zone and vehicle type.": "admin.ui.configure_ride_now_and_ride_later_pricing_per_zone_and_vehicle_type",
  "Configure sub-service masters": "admin.ui.configure_sub_service_masters",
  "Configure Zones": "admin.ui.configure_zones",
  "Configured": "admin.ui.configured",
  "Confirm & apply": "admin.ui.confirm_apply",
  "Confirm & Pay": "admin.ui.confirm_pay",
  "Confirm Password": "admin.ui.confirm_password",
  "Confirmed": "admin.ui.confirmed",
  "Consultation Types": "admin.ui.consultation_types",
  "Consultation types, specializations, and session rules.": "admin.ui.consultation_types_specializations_and_session_rules",
  "Contact Phone": "admin.ui.contact_phone",
  "Contract": "admin.ui.contract",
  "Contract type": "admin.ui.contract_type",
  "Control which admin screens each role can open — view or full manage access per page.": "admin.ui.control_which_admin_screens_each_role_can_open_view_or_full_manage_access_per_pa",
  "Coordinate": "admin.ui.coordinate",
  "Core": "admin.ui.core",
  "Corporate Clients": "admin.ui.corporate_clients",
  "Cost": "admin.ui.cost",
  "Countries": "admin.ui.countries",
  "Countries — used in zone management and all services": "admin.ui.countries_used_in_zone_management_and_all_services",
  "Countries (comma-separated)": "admin.ui.countries_comma_separated",
  "Country": "admin.ui.country",
  "Country Required": "admin.ui.country_required",
  "Courier": "admin.ui.courier",
  "Cover Image": "admin.ui.cover_image",
  "Create": "admin.ui.create",
  "Create and edit master groups and types — no code deploy required.": "admin.ui.create_and_edit_master_groups_and_types_no_code_deploy_required",
  "Create Zone": "admin.ui.create_zone",
  "Create zones with polygon boundaries": "admin.ui.create_zones_with_polygon_boundaries",
  "Create, configure, suspend, and manage SaaS clients with full lifecycle control.": "admin.ui.create_configure_suspend_and_manage_saas_clients_with_full_lifecycle_control",
  "Created": "admin.ui.created",
  "Credentials (JSON)": "admin.ui.credentials_json",
  "Credit": "admin.ui.credit",
  "Credit limit": "admin.ui.credit_limit",
  "Credit Limit": "admin.ui.credit_limit_2",
  "Critical": "admin.ui.critical",
  "Cuisine": "admin.ui.cuisine",
  "Cuisine types + dietary tags (Veg / Non-Veg)": "admin.ui.cuisine_types_dietary_tags_veg_non_veg",
  "Currencies": "admin.ui.currencies",
  "Currency": "admin.ui.currency",
  "Custom": "admin.ui.custom",
  "Custom domain": "admin.ui.custom_domain",
  "Custom services use Food or Grocery order flows": "admin.ui.custom_services_use_food_or_grocery_order_flows",
  "Customer": "admin.ui.customer",
  "Customer App": "admin.ui.customer_app",
  "Customer books ride": "admin.ui.customer_books_ride",
  "Customers": "admin.ui.customers",
  "Customers, revenue, zones, and service volumes": "admin.ui.customers_revenue_zones_and_service_volumes",
  "Daily": "admin.ui.daily",
  "Daily / weekly earnings summary": "admin.ui.daily_weekly_earnings_summary",
  "Dark Store (quick commerce)": "admin.ui.dark_store_quick_commerce",
  "Dashboard Builder": "admin.ui.dashboard_builder",
  "Dashboard Engine": "admin.ui.dashboard_engine",
  "Data Source": "admin.ui.data_source",
  "Date": "admin.ui.date",
  "Date of Birth": "admin.ui.date_of_birth",
  "Day": "admin.ui.day",
  "Deactivate": "admin.ui.deactivate",
  "Deactivate document group?": "admin.ui.deactivate_document_group",
  "Deactivate document type?": "admin.ui.deactivate_document_type",
  "Deactivate group": "admin.ui.deactivate_group",
  "Deactivate service?": "admin.ui.deactivate_service",
  "Deactivate subscription plan?": "admin.ui.deactivate_subscription_plan",
  "Deactivated": "admin.ui.deactivated",
  "Default": "admin.ui.default",
  "Default language": "admin.ui.default_language",
  "Default modules, highlights, and visibility": "admin.ui.default_modules_highlights_and_visibility",
  "Default: Welcome@2024": "admin.ui.default_welcome_2024",
  "Delete": "admin.ui.delete",
  "Delete record?": "admin.ui.delete_record",
  "Delete service": "admin.ui.delete_service",
  "Delete subscription plan": "admin.ui.delete_subscription_plan",
  "Delete subscription plan?": "admin.ui.delete_subscription_plan_2",
  "Delete zone?": "admin.ui.delete_zone",
  "Deleted": "admin.ui.deleted",
  "Delivered": "admin.ui.delivered",
  "Delivered, cancelled, and past restaurant orders": "admin.ui.delivered_cancelled_and_past_restaurant_orders",
  "Delivered, cancelled, and past store orders": "admin.ui.delivered_cancelled_and_past_store_orders",
  "Delivered, cancelled, and refunded food orders": "admin.ui.delivered_cancelled_and_refunded_food_orders",
  "Deliveries": "admin.ui.deliveries",
  "Delivering": "admin.ui.delivering",
  "Delivery": "admin.ui.delivery",
  "Delivery Address": "admin.ui.delivery_address",
  "Delivery Address *": "admin.ui.delivery_address_2",
  "Delivery assigned": "admin.ui.delivery_assigned",
  "Delivery Fees": "admin.ui.delivery_fees",
  "Delivery Modes": "admin.ui.delivery_modes",
  "Delivery partner": "admin.ui.delivery_partner",
  "Delivery Partner": "admin.ui.delivery_partner_2",
  "Delivery partners": "admin.ui.delivery_partners",
  "Delivery Partners": "admin.ui.delivery_partners_2",
  "Delivery Person — Complete Flow": "admin.ui.delivery_person_complete_flow",
  "Delivery Radius (km)": "admin.ui.delivery_radius_km",
  "Delivery radius + zone fee slots": "admin.ui.delivery_radius_zone_fee_slots",
  "Delivery Slots": "admin.ui.delivery_slots",
  "Delivery zones + slot windows": "admin.ui.delivery_zones_slot_windows",
  "Demo ready": "admin.ui.demo_ready",
  "Denied": "admin.ui.denied",
  "Department": "admin.ui.department",
  "Depots, vehicle taxonomy, and zone-wise rental packages with per-vehicle pricing.": "admin.ui.depots_vehicle_taxonomy_and_zone_wise_rental_packages_with_per_vehicle_pricing",
  "Deprecated": "admin.ui.deprecated",
  "Describe the situation, contacts made, and resolution steps…": "admin.ui.describe_the_situation_contacts_made_and_resolution_steps",
  "Description": "admin.ui.description",
  "Details": "admin.ui.details",
  "Diamond": "admin.ui.diamond",
  "Dietary Type": "admin.ui.dietary_type",
  "Dine In": "admin.ui.dine_in",
  "Direct Order": "admin.ui.direct_order",
  "Discount": "admin.ui.discount",
  "Discount & Offers": "admin.ui.discount_offers",
  "Discount codes applied at food checkout for your restaurant": "admin.ui.discount_codes_applied_at_food_checkout_for_your_restaurant",
  "Discount codes for Food, Grocery, and Transport — synced to mobile checkout.": "admin.ui.discount_codes_for_food_grocery_and_transport_synced_to_mobile_checkout",
  "Discount codes synced to Food cart, Grocery checkout, and Transport fare": "admin.ui.discount_codes_synced_to_food_cart_grocery_checkout_and_transport_fare",
  "Discount type": "admin.ui.discount_type",
  "Discount Type": "admin.ui.discount_type_2",
  "Discount value": "admin.ui.discount_value",
  "Discount Value": "admin.ui.discount_value_2",
  "Discounts": "admin.ui.discounts",
  "Dispatch": "admin.ui.dispatch",
  "Dispatch Queue": "admin.ui.dispatch_queue",
  "Dispatcher": "admin.ui.dispatcher",
  "Dispatcher — live rides & orders": "admin.ui.dispatcher_live_rides_orders",
  "Dispatcher Live Map": "admin.ui.dispatcher_live_map",
  "Dispatcher operations (live rides / orders)": "admin.ui.dispatcher_operations_live_rides_orders",
  "Dispatcher ready": "admin.ui.dispatcher_ready",
  "Display name": "admin.ui.display_name",
  "Display Order": "admin.ui.display_order",
  "Distance (km)": "admin.ui.distance_km",
  "Distance (KM)": "admin.ui.distance_km_2",
  "Document": "admin.ui.document",
  "Document active": "admin.ui.document_active",
  "Document Groups": "admin.ui.document_groups",
  "Document name": "admin.ui.document_name",
  "Document number (optional)": "admin.ui.document_number_optional",
  "Document number required": "admin.ui.document_number_required",
  "Document Review": "admin.ui.document_review",
  "Documents": "admin.ui.documents",
  "Documents waiting": "admin.ui.documents_waiting",
  "Documents, vehicle, and bank details": "admin.ui.documents_vehicle_and_bank_details",
  "Domain": "admin.ui.domain",
  "Draft": "admin.ui.draft",
  "Driver": "admin.ui.driver",
  "Driver / Taxi Partner": "admin.ui.driver_taxi_partner",
  "Driver Allowance": "admin.ui.driver_allowance",
  "Driver Assigned": "admin.ui.driver_assigned",
  "Driver Documents": "admin.ui.driver_documents",
  "Driver ID": "admin.ui.driver_id",
  "Driver leaderboard": "admin.ui.driver_leaderboard",
  "Driver Management": "admin.ui.driver_management",
  "Driver Notes": "admin.ui.driver_notes",
  "Driver Onboarding + KYC": "admin.ui.driver_onboarding_kyc",
  "Driver payout settled": "admin.ui.driver_payout_settled",
  "Driver Performance": "admin.ui.driver_performance",
  "Driver Registration": "admin.ui.driver_registration",
  "Drivers": "admin.ui.drivers",
  "Drivers Review List": "admin.ui.drivers_review_list",
  "Drop": "admin.ui.drop",
  "Drop-off": "admin.ui.drop_off",
  "Drop-off Location": "admin.ui.drop_off_location",
  "Dropoff Address": "admin.ui.dropoff_address",
  "Duration (min)": "admin.ui.duration_min",
  "Dynamic bookable services from Transport Hub — zone pricing, not Ride Category masters": "admin.ui.dynamic_bookable_services_from_transport_hub_zone_pricing_not_ride_category_mast",
  "Dynamic Engine": "admin.ui.dynamic_engine",
  "e.g. 1 plate, 250g": "admin.ui.e_g_1_plate_250g",
  "e.g. 2 hr / 40 km": "admin.ui.e_g_2_hr_40_km",
  "e.g. nav.dashboard": "admin.ui.e_g_nav_dashboard",
  "e.g. Operations, Dispatch": "admin.ui.e_g_operations_dispatch",
  "e.g. Pharmacy Delivery": "admin.ui.e_g_pharmacy_delivery",
  "e.g. rideNumber, firstName, fareTotal": "admin.ui.e_g_ridenumber_firstname_faretotal",
  "e.g. SEDAN, SUV, BIKE": "admin.ui.e_g_sedan_suv_bike",
  "e.g. status, metricCode": "admin.ui.e_g_status_metriccode",
  "e.g. transport_masters, food_masters, pricing": "admin.ui.e_g_transport_masters_food_masters_pricing",
  "Earn Per ₹": "admin.ui.earn_per",
  "Earn Rate": "admin.ui.earn_rate",
  "Earnings": "admin.ui.earnings",
  "Earnings Detail": "admin.ui.earnings_detail",
  "Earnings Reports": "admin.ui.earnings_reports",
  "Earnings target": "admin.ui.earnings_target",
  "Edit": "admin.ui.edit",
  "Edit group": "admin.ui.edit_group",
  "Edit service": "admin.ui.edit_service",
  "Edit zone": "admin.ui.edit_zone",
  "Effective From": "admin.ui.effective_from",
  "Email": "admin.ui.email",
  "Emergency Contact": "admin.ui.emergency_contact",
  "Employee": "admin.ui.employee",
  "Employee (Staff)": "admin.ui.employee_staff",
  "Employee / Staff": "admin.ui.employee_staff_2",
  "Employee ID": "admin.ui.employee_id",
  "Enable modules for tenant": "admin.ui.enable_modules_for_tenant",
  "Enable this service in zones": "admin.ui.enable_this_service_in_zones",
  "Enable this sub-service in each zone": "admin.ui.enable_this_sub_service_in_each_zone",
  "Enabled": "admin.ui.enabled",
  "End Date": "admin.ui.end_date",
  "End-to-end food delivery operations": "admin.ui.end_to_end_food_delivery_operations",
  "Ends at": "admin.ui.ends_at",
  "English": "admin.ui.english",
  "English slug xxxx-xxxx format": "admin.ui.english_slug_xxxx_xxxx_format",
  "Enter 4-digit code": "admin.ui.enter_4_digit_code",
  "Escalated": "admin.ui.escalated",
  "Escalations": "admin.ui.escalations",
  "EUR — Euro": "admin.ui.eur_euro",
  "Europe/Berlin (CET)": "admin.ui.europe_berlin_cet",
  "Europe/London (GMT)": "admin.ui.europe_london_gmt",
  "Event": "admin.ui.event",
  "Event code": "admin.ui.event_code",
  "Event Vendor / Organizer": "admin.ui.event_vendor_organizer",
  "Events & Tickets": "admin.ui.events_tickets",
  "example: payu": "admin.ui.example_payu",
  "Exchange Rates": "admin.ui.exchange_rates",
  "Experience Levels": "admin.ui.experience_levels",
  "Expired": "admin.ui.expired",
  "Expiry date": "admin.ui.expiry_date",
  "Expiry required": "admin.ui.expiry_required",
  "Explain what the partner should fix and re-upload": "admin.ui.explain_what_the_partner_should_fix_and_re_upload",
  "Extra KM Price": "admin.ui.extra_km_price",
  "Fare": "admin.ui.fare",
  "Fare calculator": "admin.ui.fare_calculator",
  "Fare from zone matrix": "admin.ui.fare_from_zone_matrix",
  "Fat (g)": "admin.ui.fat_g",
  "Favicon": "admin.ui.favicon",
  "Featured": "admin.ui.featured",
  "Featured plan": "admin.ui.featured_plan",
  "Features, badges, and visibility": "admin.ui.features_badges_and_visibility",
  "Female": "admin.ui.female",
  "Festival": "admin.ui.festival",
  "Fiber (g)": "admin.ui.fiber_g",
  "File URL": "admin.ui.file_url",
  "Filter by zone name or code": "admin.ui.filter_by_zone_name_or_code",
  "Finance": "admin.ui.finance",
  "Finance: settlements + reports": "admin.ui.finance_settlements_reports",
  "First Name": "admin.ui.first_name",
  "First order only": "admin.ui.first_order_only",
  "Fixed": "admin.ui.fixed",
  "Fixed (₹)": "admin.ui.fixed_2",
  "Fixed amount (₹)": "admin.ui.fixed_amount",
  "Fleet Branch": "admin.ui.fleet_branch",
  "Fleet Branch / Depot": "admin.ui.fleet_branch_depot",
  "Fleet depots, rental-enabled vehicle types, and hour/km packages — like transport rental management.": "admin.ui.fleet_depots_rental_enabled_vehicle_types_and_hour_km_packages_like_transport_re",
  "Follow the recommended order to configure this sub-service.": "admin.ui.follow_the_recommended_order_to_configure_this_sub_service",
  "Font family": "admin.ui.font_family",
  "Food": "admin.ui.food",
  "Food & Grocery Delivery — Complete Flow": "admin.ui.food_grocery_delivery_complete_flow",
  "Food Add Screen": "admin.ui.food_add_screen",
  "Food and Grocery services": "admin.ui.food_and_grocery_services",
  "Food Attributes": "admin.ui.food_attributes",
  "Food Catalog": "admin.ui.food_catalog",
  "Food Code": "admin.ui.food_code",
  "Food Delivery": "admin.ui.food_delivery",
  "Food Delivery — End-to-End Flow": "admin.ui.food_delivery_end_to_end_flow",
  "Food Delivery Operations": "admin.ui.food_delivery_operations",
  "Food Home Banners": "admin.ui.food_home_banners",
  "Food Images": "admin.ui.food_images",
  "Food Items": "admin.ui.food_items",
  "Food Name": "admin.ui.food_name",
  "Food Order History": "admin.ui.food_order_history",
  "Food Orders": "admin.ui.food_orders",
  "Food Tags": "admin.ui.food_tags",
  "Food-style (restaurants / meals)": "admin.ui.food_style_restaurants_meals",
  "France": "admin.ui.france",
  "Free waiting (min)": "admin.ui.free_waiting_min",
  "Free Waiting Time": "admin.ui.free_waiting_time",
  "Friday": "admin.ui.friday",
  "From": "admin.ui.from",
  "From City": "admin.ui.from_city",
  "From Date": "admin.ui.from_date",
  "FSSAI Number": "admin.ui.fssai_number",
  "Fuel Type": "admin.ui.fuel_type",
  "Fulfillment, SKU templates, tax": "admin.ui.fulfillment_sku_templates_tax",
  "Full analytics dashboard": "admin.ui.full_analytics_dashboard",
  "Full audit log visibility across all tenants": "admin.ui.full_audit_log_visibility_across_all_tenants",
  "Full CRUD with search, filter, and CSV export": "admin.ui.full_crud_with_search_filter_and_csv_export",
  "Full Function Reference": "admin.ui.full_function_reference",
  "Full partner review": "admin.ui.full_partner_review",
  "Full product records with variants, addons, and metadata from Food Add Wizard": "admin.ui.full_product_records_with_variants_addons_and_metadata_from_food_add_wizard",
  "Full store master — identity, location, compliance, delivery settings, timing, and revenue.": "admin.ui.full_store_master_identity_location_compliance_delivery_settings_timing_and_reve",
  "Gateway Type": "admin.ui.gateway_type",
  "GBP — British Pound": "admin.ui.gbp_british_pound",
  "Gender": "admin.ui.gender",
  "General": "admin.ui.general",
  "Germany": "admin.ui.germany",
  "Global permission & role templates": "admin.ui.global_permission_role_templates",
  "Go Online": "admin.ui.go_online",
  "Gold": "admin.ui.gold",
  "Grace (min)": "admin.ui.grace_min",
  "Grace period (days)": "admin.ui.grace_period_days",
  "Grocery": "admin.ui.grocery",
  "Grocery Add Screen": "admin.ui.grocery_add_screen",
  "Grocery Delivery": "admin.ui.grocery_delivery",
  "Grocery Delivery — Complete Flow": "admin.ui.grocery_delivery_complete_flow",
  "Grocery Delivery — End-to-End Flow": "admin.ui.grocery_delivery_end_to_end_flow",
  "Grocery History": "admin.ui.grocery_history",
  "Grocery Home Banners": "admin.ui.grocery_home_banners",
  "Grocery home carousel in customer app": "admin.ui.grocery_home_carousel_in_customer_app",
  "Grocery Order History": "admin.ui.grocery_order_history",
  "Grocery Orders": "admin.ui.grocery_orders",
  "Grocery store onboarding + verification": "admin.ui.grocery_store_onboarding_verification",
  "Grocery Stores": "admin.ui.grocery_stores",
  "Grocery-style (stores / catalog)": "admin.ui.grocery_style_stores_catalog",
  "Gross": "admin.ui.gross",
  "Gross Revenue": "admin.ui.gross_revenue",
  "Group": "admin.ui.group",
  "Group active": "admin.ui.group_active",
  "Group By field": "admin.ui.group_by_field",
  "Group Key": "admin.ui.group_key",
  "Group name": "admin.ui.group_name",
  "Groups and modifiers": "admin.ui.groups_and_modifiers",
  "Groups like Toppings, Sides, Beverages — each with priced addons.": "admin.ui.groups_like_toppings_sides_beverages_each_with_priced_addons",
  "GST %": "admin.ui.gst",
  "GST Number": "admin.ui.gst_number",
  "Handles food, grocery, and parcel deliveries. Same partner, multiple services.": "admin.ui.handles_food_grocery_and_parcel_deliveries_same_partner_multiple_services",
  "Handoff OTP": "admin.ui.handoff_otp",
  "Heat Points": "admin.ui.heat_points",
  "Heavy Order": "admin.ui.heavy_order",
  "Helpdesk": "admin.ui.helpdesk",
  "High": "admin.ui.high",
  "Hold and drag on the map to draw a box": "admin.ui.hold_and_drag_on_the_map_to_draw_a_box",
  "Holidays": "admin.ui.holidays",
  "Home Banners": "admin.ui.home_banners",
  "Home carousel per service (Food / Grocery / Transport)": "admin.ui.home_carousel_per_service_food_grocery_transport",
  "Home delivery": "admin.ui.home_delivery",
  "Hour and kilometer rental package master — define packages per vehicle type.": "admin.ui.hour_and_kilometer_rental_package_master_define_packages_per_vehicle_type",
  "Hour/km bundles with per-vehicle pricing": "admin.ui.hour_km_bundles_with_per_vehicle_pricing",
  "Hourly job volume — transport and delivery": "admin.ui.hourly_job_volume_transport_and_delivery",
  "Hours": "admin.ui.hours",
  "How drivers earn in this zone": "admin.ui.how_drivers_earn_in_this_zone",
  "Hub": "admin.ui.hub",
  "Hub tab reference — Food Delivery": "admin.ui.hub_tab_reference_food_delivery",
  "Hub tab reference — Grocery Delivery": "admin.ui.hub_tab_reference_grocery_delivery",
  "Hub tab reference — Transport": "admin.ui.hub_tab_reference_transport",
  "Icon": "admin.ui.icon",
  "In Progress": "admin.ui.in_progress",
  "In queue": "admin.ui.in_queue",
  "In tenant form": "admin.ui.in_tenant_form",
  "In-app": "admin.ui.in_app",
  "In-app popups": "admin.ui.in_app_popups",
  "IN,US,UAE": "admin.ui.in_us_uae",
  "Inactive": "admin.ui.inactive",
  "Incentive campaigns": "admin.ui.incentive_campaigns",
  "Incentive Options": "admin.ui.incentive_options",
  "Incentive Type": "admin.ui.incentive_type",
  "Incentives & Bonuses": "admin.ui.incentives_bonuses",
  "Incident report *": "admin.ui.incident_report",
  "Included": "admin.ui.included",
  "India": "admin.ui.india",
  "Individual users (search & multiselect)": "admin.ui.individual_users_search_multiselect",
  "Ingredient & Recipe": "admin.ui.ingredient_recipe",
  "INR — Indian Rupee": "admin.ui.inr_indian_rupee",
  "Internal Admin Notes": "admin.ui.internal_admin_notes",
  "Interval": "admin.ui.interval",
  "Invoices": "admin.ui.invoices",
  "Item": "admin.ui.item",
  "Items": "admin.ui.items",
  "Japan": "admin.ui.japan",
  "Job description": "admin.ui.job_description",
  "Joined": "admin.ui.joined",
  "JPY — Japanese Yen": "admin.ui.jpy_japanese_yen",
  "Jump to key admin areas": "admin.ui.jump_to_key_admin_areas",
  "Key": "admin.ui.key",
  "Key ID": "admin.ui.key_id",
  "Key Secret": "admin.ui.key_secret",
  "Kitchen Station": "admin.ui.kitchen_station",
  "Km": "admin.ui.km",
  "KM slab + trip type packages — configure all vehicle fares in one add, like rental management.": "admin.ui.km_slab_trip_type_packages_configure_all_vehicle_fares_in_one_add_like_rental_ma",
  "Label": "admin.ui.label",
  "Language": "admin.ui.language",
  "Languages": "admin.ui.languages",
  "Languages (comma separated)": "admin.ui.languages_comma_separated",
  "Languages, currencies, timezones, tax regions": "admin.ui.languages_currencies_timezones_tax_regions",
  "Last Login": "admin.ui.last_login",
  "Last Name": "admin.ui.last_name",
  "Latest transport and delivery jobs": "admin.ui.latest_transport_and_delivery_jobs",
  "Latitude": "admin.ui.latitude",
  "Leaderboard": "admin.ui.leaderboard",
  "Leaderboard rankings and incentive campaigns": "admin.ui.leaderboard_rankings_and_incentive_campaigns",
  "Leave empty for all service hubs": "admin.ui.leave_empty_for_all_service_hubs",
  "Leave empty for all zones": "admin.ui.leave_empty_for_all_zones",
  "Leave empty for full refund": "admin.ui.leave_empty_for_full_refund",
  "Lifetime": "admin.ui.lifetime",
  "Limit": "admin.ui.limit",
  "Line Chart": "admin.ui.line_chart",
  "List": "admin.ui.list",
  "List Source": "admin.ui.list_source",
  "Live": "admin.ui.live",
  "Live Fleet Map": "admin.ui.live_fleet_map",
  "Live Food Orders": "admin.ui.live_food_orders",
  "Live Grocery Orders": "admin.ui.live_grocery_orders",
  "Live jobs": "admin.ui.live_jobs",
  "Live Map": "admin.ui.live_map",
  "Live map navigation integrated": "admin.ui.live_map_navigation_integrated",
  "Live Orders": "admin.ui.live_orders",
  "Live Partner Map": "admin.ui.live_partner_map",
  "Live Trip": "admin.ui.live_trip",
  "Load from masters": "admin.ui.load_from_masters",
  "Loading…": "admin.ui.loading",
  "Local": "admin.ui.local",
  "Locale & domain": "admin.ui.locale_domain",
  "Localization": "admin.ui.localization",
  "Location": "admin.ui.location",
  "Location, preferences, and internal admin notes": "admin.ui.location_preferences_and_internal_admin_notes",
  "Logo": "admin.ui.logo",
  "Longitude": "admin.ui.longitude",
  "Low": "admin.ui.low",
  "Lower numbers appear first in lists": "admin.ui.lower_numbers_appear_first_in_lists",
  "Lowest": "admin.ui.lowest",
  "Loyalty": "admin.ui.loyalty",
  "Male": "admin.ui.male",
  "Manage": "admin.ui.manage",
  "Manage all tenants (create / suspend / config)": "admin.ui.manage_all_tenants_create_suspend_config",
  "Manage customer support tickets": "admin.ui.manage_customer_support_tickets",
  "Manage documents": "admin.ui.manage_documents",
  "Manage hour/km rental packages for this zone. Same flow as Caby rental master.": "admin.ui.manage_hour_km_rental_packages_for_this_zone_same_flow_as_caby_rental_master",
  "Manage partner subscription plans": "admin.ui.manage_partner_subscription_plans",
  "Manage Partners": "admin.ui.manage_partners",
  "Manage plans": "admin.ui.manage_plans",
  "Manage riders": "admin.ui.manage_riders",
  "Manage Tenants": "admin.ui.manage_tenants",
  "Manage vehicle categories — capacity, service type, and availability.": "admin.ui.manage_vehicle_categories_capacity_service_type_and_availability",
  "Manage Venues (Masters)": "admin.ui.manage_venues_masters",
  "Mandatory": "admin.ui.mandatory",
  "Manual Order": "admin.ui.manual_order",
  "Manual Ride Booking": "admin.ui.manual_ride_booking",
  "Map color": "admin.ui.map_color",
  "Mark Ready": "admin.ui.mark_ready",
  "Marketplace": "admin.ui.marketplace",
  "Master Builder": "admin.ui.master_builder",
  "Master Data": "admin.ui.master_data",
  "Master data & locale": "admin.ui.master_data_locale",
  "Master data builder (global masters)": "admin.ui.master_data_builder_global_masters",
  "Master Group Keys (comma-separated)": "admin.ui.master_group_keys_comma_separated",
  "Masters": "admin.ui.masters",
  "Max": "admin.ui.max",
  "Max discount (₹)": "admin.ui.max_discount",
  "Max KM": "admin.ui.max_km",
  "Max qty": "admin.ui.max_qty",
  "Max Redeem %": "admin.ui.max_redeem",
  "Max rides per period": "admin.ui.max_rides_per_period",
  "Max users": "admin.ui.max_users",
  "Max uses / user": "admin.ui.max_uses_user",
  "Max zones": "admin.ui.max_zones",
  "Menu & Catalog": "admin.ui.menu_catalog",
  "Menu builder — categories, variants, addons": "admin.ui.menu_builder_categories_variants_addons",
  "Menu Catalog": "admin.ui.menu_catalog_2",
  "Menu Item": "admin.ui.menu_item",
  "Menus": "admin.ui.menus",
  "Merchant": "admin.ui.merchant",
  "Merchant / Store Owner": "admin.ui.merchant_store_owner",
  "Merchant Account": "admin.ui.merchant_account",
  "Merchant Onboarding": "admin.ui.merchant_onboarding",
  "Merchant Subscription Plan": "admin.ui.merchant_subscription_plan",
  "Message": "admin.ui.message",
  "Meta": "admin.ui.meta",
  "Metadata Engine": "admin.ui.metadata_engine",
  "Metric": "admin.ui.metric",
  "Metrics": "admin.ui.metrics",
  "MILE": "admin.ui.mile",
  "Min": "admin.ui.min",
  "Min Fare": "admin.ui.min_fare",
  "Min KM": "admin.ui.min_km",
  "Min order": "admin.ui.min_order",
  "Min Order": "admin.ui.min_order_2",
  "Min order (₹)": "admin.ui.min_order_3",
  "Min Order (₹)": "admin.ui.min_order_4",
  "Min Redeem": "admin.ui.min_redeem",
  "Min Redeem Points": "admin.ui.min_redeem_points",
  "Minimum Fare": "admin.ui.minimum_fare",
  "Missing": "admin.ui.missing",
  "Mobile": "admin.ui.mobile",
  "Mobile / web push": "admin.ui.mobile_web_push",
  "Mobile home banners for Food, Grocery, and Transport tabs": "admin.ui.mobile_home_banners_for_food_grocery_and_transport_tabs",
  "Mobile number": "admin.ui.mobile_number",
  "Mobile Number": "admin.ui.mobile_number_2",
  "Mode": "admin.ui.mode",
  "Module": "admin.ui.module",
  "Modules": "admin.ui.modules",
  "Modules & publish": "admin.ui.modules_publish",
  "Monday": "admin.ui.monday",
  "Monitor all rides with live status, filter by date range, status, and trip type.": "admin.ui.monitor_all_rides_with_live_status_filter_by_date_range_status_and_trip_type",
  "Monitor earnings & process settlements": "admin.ui.monitor_earnings_process_settlements",
  "Monitor live dispatch queue": "admin.ui.monitor_live_dispatch_queue",
  "Monitor Operations": "admin.ui.monitor_operations",
  "Monitor Orders": "admin.ui.monitor_orders",
  "Monthly": "admin.ui.monthly",
  "MSG91": "admin.ui.msg91",
  "Multi Order": "admin.ui.multi_order",
  "Multi-city operator branches": "admin.ui.multi_city_operator_branches",
  "Multi-Currency": "admin.ui.multi_currency",
  "Multi-outlet SaaS": "admin.ui.multi_outlet_saas",
  "Multi-restaurant ordering with real-time tracking": "admin.ui.multi_restaurant_ordering_with_real_time_tracking",
  "Multi-service: food + grocery + parcel same shift": "admin.ui.multi_service_food_grocery_parcel_same_shift",
  "Multi-store grocery ordering with slot-based delivery": "admin.ui.multi_store_grocery_ordering_with_slot_based_delivery",
  "Multiplier": "admin.ui.multiplier",
  "My Current Location": "admin.ui.my_current_location",
  "My Profile": "admin.ui.my_profile",
  "Myself": "admin.ui.myself",
  "Name": "admin.ui.name",
  "Name or phone": "admin.ui.name_or_phone",
  "Name, contact, avatar, and identity details": "admin.ui.name_contact_avatar_and_identity_details",
  "Name, phone, email…": "admin.ui.name_phone_email",
  "Navigate Pickup": "admin.ui.navigate_pickup",
  "Navigate to Customer": "admin.ui.navigate_to_customer",
  "Needs Action": "admin.ui.needs_action",
  "New customer registrations": "admin.ui.new_customer_registrations",
  "New Order Alert": "admin.ui.new_order_alert",
  "Next": "admin.ui.next",
  "Night": "admin.ui.night",
  "No activity in the last 24 hours": "admin.ui.no_activity_in_the_last_24_hours",
  "No mix data": "admin.ui.no_mix_data",
  "No outcome data": "admin.ui.no_outcome_data",
  "No per-km charge within base": "admin.ui.no_per_km_charge_within_base",
  "No revenue data yet": "admin.ui.no_revenue_data_yet",
  "No service data": "admin.ui.no_service_data",
  "No user growth data": "admin.ui.no_user_growth_data",
  "No zone": "admin.ui.no_zone",
  "No zones configured": "admin.ui.no_zones_configured",
  "No zones yet — create in Zone Management": "admin.ui.no_zones_yet_create_in_zone_management",
  "Non Verified": "admin.ui.non_verified",
  "Non-service zone": "admin.ui.non_service_zone",
  "Not uploaded": "admin.ui.not_uploaded",
  "Note (optional)": "admin.ui.note_optional",
  "Notification templates": "admin.ui.notification_templates",
  "Offer": "admin.ui.offer",
  "Offer Price (₹)": "admin.ui.offer_price",
  "Offers & Coupons": "admin.ui.offers_coupons",
  "Offline": "admin.ui.offline",
  "On": "admin.ui.on",
  "On Demand Services": "admin.ui.on_demand_services",
  "On Trip": "admin.ui.on_trip",
  "On-demand rides with zone-based pricing and bidding": "admin.ui.on_demand_rides_with_zone_based_pricing_and_bidding",
  "On-Demand Service Provider": "admin.ui.on_demand_service_provider",
  "On-Demand Setup Guide": "admin.ui.on_demand_setup_guide",
  "Onboard & verify drivers": "admin.ui.onboard_verify_drivers",
  "Onboard Drivers": "admin.ui.onboard_drivers",
  "Onboard drivers and assign zones": "admin.ui.onboard_drivers_and_assign_zones",
  "Onboard Partners": "admin.ui.onboard_partners",
  "Onboard Restaurants": "admin.ui.onboard_restaurants",
  "Onboard Stores": "admin.ui.onboard_stores",
  "Onboarding": "admin.ui.onboarding",
  "Onboarding Hub": "admin.ui.onboarding_hub",
  "Onboarding waiting": "admin.ui.onboarding_waiting",
  "One benefit per line\\ne.g. Email support\\n3 service hubs": "admin.ui.one_benefit_per_line_ne_g_email_support_n3_service_hubs",
  "One benefit per line\\ne.g. No commission on rides\\nPriority dispatch": "admin.ui.one_benefit_per_line_ne_g_no_commission_on_rides_npriority_dispatch",
  "One master: zone + vehicle + trip type": "admin.ui.one_master_zone_vehicle_trip_type",
  "One Way": "admin.ui.one_way",
  "Online": "admin.ui.online",
  "Online Drivers": "admin.ui.online_drivers",
  "Online/Offline toggle with zone selection": "admin.ui.online_offline_toggle_with_zone_selection",
  "Only active partners in your tenant roster are listed": "admin.ui.only_active_partners_in_your_tenant_roster_are_listed",
  "Open": "admin.ui.open",
  "Open Dispatcher": "admin.ui.open_dispatcher",
  "Open file": "admin.ui.open_file",
  "Open in new tab": "admin.ui.open_in_new_tab",
  "Open Invoices": "admin.ui.open_invoices",
  "Open master catalog": "admin.ui.open_master_catalog",
  "Open Now": "admin.ui.open_now",
  "Open setup guide": "admin.ui.open_setup_guide",
  "Open Users": "admin.ui.open_users",
  "Open Zone Management": "admin.ui.open_zone_management",
  "Opening Hours": "admin.ui.opening_hours",
  "Operating Zone": "admin.ui.operating_zone",
  "Operating zones": "admin.ui.operating_zones",
  "Operational control with live status transitions": "admin.ui.operational_control_with_live_status_transitions",
  "Operations": "admin.ui.operations",
  "Operations dashboard (permission-gated)": "admin.ui.operations_dashboard_permission_gated",
  "Operations that need your attention": "admin.ui.operations_that_need_your_attention",
  "Optional": "admin.ui.optional",
  "Optional — multi-branch SaaS": "admin.ui.optional_multi_branch_saas",
  "Optional admin notes": "admin.ui.optional_admin_notes",
  "Optional full-day off (in addition to per-day closed switches)": "admin.ui.optional_full_day_off_in_addition_to_per_day_closed_switches",
  "Order": "admin.ui.order",
  "Order #": "admin.ui.order_2",
  "Order Assigned": "admin.ui.order_assigned",
  "Order History": "admin.ui.order_history",
  "Order No.": "admin.ui.order_no",
  "Order Notes": "admin.ui.order_notes",
  "Order placed": "admin.ui.order_placed",
  "Order Queue": "admin.ui.order_queue",
  "Orders": "admin.ui.orders",
  "Organizer Types": "admin.ui.organizer_types",
  "Organizers, venues, and policies": "admin.ui.organizers_venues_and_policies",
  "Other": "admin.ui.other",
  "Others": "admin.ui.others",
  "OTP code": "admin.ui.otp_code",
  "Out for Delivery": "admin.ui.out_for_delivery",
  "Out of zone": "admin.ui.out_of_zone",
  "Outstation": "admin.ui.outstation",
  "Outstation Management": "admin.ui.outstation_management",
  "Outstation mode": "admin.ui.outstation_mode",
  "Outstation pricing": "admin.ui.outstation_pricing",
  "Outstation Pricing": "admin.ui.outstation_pricing_2",
  "Outstation Pricing Management": "admin.ui.outstation_pricing_management",
  "Outstation Pricing Master": "admin.ui.outstation_pricing_master",
  "Outstation routes": "admin.ui.outstation_routes",
  "Owner": "admin.ui.owner",
  "Owner Name": "admin.ui.owner_name",
  "Package Group": "admin.ui.package_group",
  "Package Hours": "admin.ui.package_hours",
  "Package KM": "admin.ui.package_km",
  "Package Name": "admin.ui.package_name",
  "Parcel": "admin.ui.parcel",
  "Parent master": "admin.ui.parent_master",
  "Parking": "admin.ui.parking",
  "Partner": "admin.ui.partner",
  "Partner App": "admin.ui.partner_app",
  "Partner commission settlements for transport, food delivery, and grocery delivery.": "admin.ui.partner_commission_settlements_for_transport_food_delivery_and_grocery_delivery",
  "Partner Details": "admin.ui.partner_details",
  "Partner earning model": "admin.ui.partner_earning_model",
  "Partner Entity": "admin.ui.partner_entity",
  "Partner KYC & document review": "admin.ui.partner_kyc_document_review",
  "Partner KYC approval": "admin.ui.partner_kyc_approval",
  "Partner Onboarding": "admin.ui.partner_onboarding",
  "Partner Pricing (zone)": "admin.ui.partner_pricing_zone",
  "Partner registered": "admin.ui.partner_registered",
  "Partner Review": "admin.ui.partner_review",
  "Partner subscription plans": "admin.ui.partner_subscription_plans",
  "Partner Subscription Plans": "admin.ui.partner_subscription_plans_2",
  "Partner Tiers": "admin.ui.partner_tiers",
  "Partner type": "admin.ui.partner_type",
  "Partner user ID": "admin.ui.partner_user_id",
  "Partners": "admin.ui.partners",
  "Partners & Payout": "admin.ui.partners_payout",
  "Partners subscribed": "admin.ui.partners_subscribed",
  "partners.view, documents.verify, settings...": "admin.ui.partners_view_documents_verify_settings",
  "Passenger Name (if others)": "admin.ui.passenger_name_if_others",
  "Passenger Phone (if others)": "admin.ui.passenger_phone_if_others",
  "Password": "admin.ui.password",
  "Password, verification, and account status": "admin.ui.password_verification_and_account_status",
  "Past food orders": "admin.ui.past_food_orders",
  "Past grocery orders": "admin.ui.past_grocery_orders",
  "Past Orders": "admin.ui.past_orders",
  "Pay": "admin.ui.pay",
  "Payee": "admin.ui.payee",
  "Payment": "admin.ui.payment",
  "Payment & SMS gateway config": "admin.ui.payment_sms_gateway_config",
  "Payment gateway global config": "admin.ui.payment_gateway_global_config",
  "Payment Method": "admin.ui.payment_method",
  "Payment Methods": "admin.ui.payment_methods",
  "Payment methods, banks, payout cycles": "admin.ui.payment_methods_banks_payout_cycles",
  "Payment Type": "admin.ui.payment_type",
  "Payout": "admin.ui.payout",
  "Payout & Commission Tab": "admin.ui.payout_commission_tab",
  "Payout Cycles": "admin.ui.payout_cycles",
  "PayPal": "admin.ui.paypal",
  "Peak Hour": "admin.ui.peak_hour",
  "Peak hour bonus": "admin.ui.peak_hour_bonus",
  "Peak hour surge earnings": "admin.ui.peak_hour_surge_earnings",
  "Pending": "admin.ui.pending",
  "Pending Approval": "admin.ui.pending_approval",
  "Pending docs": "admin.ui.pending_docs",
  "Pending review": "admin.ui.pending_review",
  "Per ₹": "admin.ui.per",
  "Per day": "admin.ui.per_day",
  "Per Day": "admin.ui.per_day_2",
  "Per hour": "admin.ui.per_hour",
  "Per Hour": "admin.ui.per_hour_2",
  "Per kg rate": "admin.ui.per_kg_rate",
  "Per Kg Rate": "admin.ui.per_kg_rate_2",
  "Per KM (₹)": "admin.ui.per_km",
  "Per Km Rate": "admin.ui.per_km_rate",
  "Per Min Rate": "admin.ui.per_min_rate",
  "Per Minute": "admin.ui.per_minute",
  "Per-restaurant addon groups used in the Food Add wizard and customer customization.": "admin.ui.per_restaurant_addon_groups_used_in_the_food_add_wizard_and_customer_customizati",
  "Per-service outcome comparison": "admin.ui.per_service_outcome_comparison",
  "Percentage": "admin.ui.percentage",
  "Percentage (%)": "admin.ui.percentage_2",
  "Performance badges & incentive tiers": "admin.ui.performance_badges_incentive_tiers",
  "Period": "admin.ui.period",
  "Period intelligence": "admin.ui.period_intelligence",
  "Permission Key": "admin.ui.permission_key",
  "Permissions": "admin.ui.permissions",
  "Permit Type": "admin.ui.permit_type",
  "Phone": "admin.ui.phone",
  "Phone *": "admin.ui.phone_2",
  "PhonePe": "admin.ui.phonepe",
  "Picking & Packing": "admin.ui.picking_packing",
  "Picking Items": "admin.ui.picking_items",
  "Picking, packing, delivery workflow with stock-backed ordering.": "admin.ui.picking_packing_delivery_workflow_with_stock_backed_ordering",
  "Pickup": "admin.ui.pickup",
  "Pickup Address": "admin.ui.pickup_address",
  "Pickup branches for bike/car rental": "admin.ui.pickup_branches_for_bike_car_rental",
  "Pickup Location": "admin.ui.pickup_location",
  "Pickup OTP": "admin.ui.pickup_otp",
  "Pickup OTP (merchant) + Delivery OTP (customer)": "admin.ui.pickup_otp_merchant_delivery_otp_customer",
  "Pincode": "admin.ui.pincode",
  "Place Food Order": "admin.ui.place_food_order",
  "Place Grocery Order": "admin.ui.place_grocery_order",
  "Place Order": "admin.ui.place_order",
  "Plan": "admin.ui.plan",
  "Plan code": "admin.ui.plan_code",
  "Plan expiry": "admin.ui.plan_expiry",
  "Plan expiry (optional)": "admin.ui.plan_expiry_optional",
  "Plan features": "admin.ui.plan_features",
  "Plan highlights": "admin.ui.plan_highlights",
  "Plan info": "admin.ui.plan_info",
  "Plan name": "admin.ui.plan_name",
  "Plans": "admin.ui.plans",
  "Platform": "admin.ui.platform",
  "Platform Earnings": "admin.ui.platform_earnings",
  "Platform overview": "admin.ui.platform_overview",
  "Platform Service": "admin.ui.platform_service",
  "Platform services builder (add new services)": "admin.ui.platform_services_builder_add_new_services",
  "Platform-wide revenue reports": "admin.ui.platform_wide_revenue_reports",
  "Platinum": "admin.ui.platinum",
  "Points": "admin.ui.points",
  "Popular": "admin.ui.popular",
  "Popular, Best value": "admin.ui.popular_best_value",
  "Postal / PIN Code": "admin.ui.postal_pin_code",
  "Postpaid": "admin.ui.postpaid",
  "Prefer not to say": "admin.ui.prefer_not_to_say",
  "Preferred Language": "admin.ui.preferred_language",
  "Prepaid": "admin.ui.prepaid",
  "Preparation Time": "admin.ui.preparation_time",
  "Preparing": "admin.ui.preparing",
  "Prescription Templates": "admin.ui.prescription_templates",
  "Preview partner registration flows. Production partners onboard via the mobile app.": "admin.ui.preview_partner_registration_flows_production_partners_onboard_via_the_mobile_ap",
  "Price": "admin.ui.price",
  "Price (₹)": "admin.ui.price_2",
  "Price ₹": "admin.ui.price_3",
  "Price Per KM": "admin.ui.price_per_km",
  "Price Per Minute": "admin.ui.price_per_minute",
  "Price, billing cycle, trial, and caps": "admin.ui.price_billing_cycle_trial_and_caps",
  "Price, billing cycle, validity, and ride limits": "admin.ui.price_billing_cycle_validity_and_ride_limits",
  "Pricing": "admin.ui.pricing",
  "Pricing & limits": "admin.ui.pricing_limits",
  "Pricing & rules": "admin.ui.pricing_rules",
  "Pricing pending": "admin.ui.pricing_pending",
  "Pricing Rules": "admin.ui.pricing_rules_2",
  "Pricing set": "admin.ui.pricing_set",
  "Pricing support masters": "admin.ui.pricing_support_masters",
  "Pricing Templates": "admin.ui.pricing_templates",
  "Primary color": "admin.ui.primary_color",
  "Primary Color": "admin.ui.primary_color_2",
  "Primary zone": "admin.ui.primary_zone",
  "Priority": "admin.ui.priority",
  "Product": "admin.ui.product",
  "Product Catalog": "admin.ui.product_catalog",
  "Product catalog — Grocery Add wizard with images": "admin.ui.product_catalog_grocery_add_wizard_with_images",
  "Product Catalog + Inventory": "admin.ui.product_catalog_inventory",
  "Product Image": "admin.ui.product_image",
  "Product Images": "admin.ui.product_images",
  "Product images and delivery windows": "admin.ui.product_images_and_delivery_windows",
  "Product Name": "admin.ui.product_name",
  "Product Variants": "admin.ui.product_variants",
  "Products / Inventory": "admin.ui.products_inventory",
  "Products & Inventory": "admin.ui.products_inventory_2",
  "Professional store profile — identity, location, compliance, timing, and revenue.": "admin.ui.professional_store_profile_identity_location_compliance_timing_and_revenue",
  "Profile": "admin.ui.profile",
  "Profile Photo": "admin.ui.profile_photo",
  "Promo": "admin.ui.promo",
  "Promo code": "admin.ui.promo_code",
  "Promo Code": "admin.ui.promo_code_2",
  "Promo codes + discount management": "admin.ui.promo_codes_discount_management",
  "Promo Codes + Discounts": "admin.ui.promo_codes_discounts",
  "Promo codes + loyalty configuration": "admin.ui.promo_codes_loyalty_configuration",
  "Promo codes + offers": "admin.ui.promo_codes_offers",
  "Promo Codes + Offers": "admin.ui.promo_codes_offers_2",
  "Promo Coupons": "admin.ui.promo_coupons",
  "Promos & Coupons": "admin.ui.promos_coupons",
  "Properties": "admin.ui.properties",
  "Protein (g)": "admin.ui.protein_g",
  "Provider": "admin.ui.provider",
  "Provider Earnings": "admin.ui.provider_earnings",
  "Providers": "admin.ui.providers",
  "Publish": "admin.ui.publish",
  "Publishable Key": "admin.ui.publishable_key",
  "Pure Veg": "admin.ui.pure_veg",
  "Push notifications": "admin.ui.push_notifications",
  "Qty": "admin.ui.qty",
  "Quantity": "admin.ui.quantity",
  "Queue": "admin.ui.queue",
  "Quick access": "admin.ui.quick_access",
  "Radius": "admin.ui.radius",
  "Rain": "admin.ui.rain",
  "Rank by": "admin.ui.rank_by",
  "Rate": "admin.ui.rate",
  "Rate & Review": "admin.ui.rate_review",
  "Rate Ride": "admin.ui.rate_ride",
  "Rating": "admin.ui.rating",
  "Razorpay": "admin.ui.razorpay",
  "Reason": "admin.ui.reason",
  "Reason shown to the partner": "admin.ui.reason_shown_to_the_partner",
  "Receive Request": "admin.ui.receive_request",
  "Recent activity": "admin.ui.recent_activity",
  "Recommended": "admin.ui.recommended",
  "Redeem ₹/point": "admin.ui.redeem_point",
  "Redeem ₹/pt": "admin.ui.redeem_pt",
  "Ref": "admin.ui.ref",
  "Reference": "admin.ui.reference",
  "Referral code": "admin.ui.referral_code",
  "Referral Code": "admin.ui.referral_code_2",
  "Referred user": "admin.ui.referred_user",
  "Refresh": "admin.ui.refresh",
  "Refresh balance": "admin.ui.refresh_balance",
  "Refresh list": "admin.ui.refresh_list",
  "Refund & cancellation policy": "admin.ui.refund_cancellation_policy",
  "Refund Policies": "admin.ui.refund_policies",
  "Reject": "admin.ui.reject",
  "Rejected": "admin.ui.rejected",
  "Rejection reason": "admin.ui.rejection_reason",
  "Rejection Reasons": "admin.ui.rejection_reasons",
  "Remove": "admin.ui.remove",
  "Remove product?": "admin.ui.remove_product",
  "Remove restaurant?": "admin.ui.remove_restaurant",
  "Remove store?": "admin.ui.remove_store",
  "Rental": "admin.ui.rental",
  "Rental Management": "admin.ui.rental_management",
  "Rental package": "admin.ui.rental_package",
  "Rental Package Management": "admin.ui.rental_package_management",
  "Rental Package Master": "admin.ui.rental_package_master",
  "Rental packages": "admin.ui.rental_packages",
  "Rental Packages": "admin.ui.rental_packages_2",
  "Reply": "admin.ui.reply",
  "Report": "admin.ui.report",
  "Report Builder": "admin.ui.report_builder",
  "Report Type": "admin.ui.report_type",
  "Reports": "admin.ui.reports",
  "Reports & settlements (if permitted)": "admin.ui.reports_settlements_if_permitted",
  "Required": "admin.ui.required",
  "Resolved": "admin.ui.resolved",
  "Resource": "admin.ui.resource",
  "Resource ID": "admin.ui.resource_id",
  "Restaurant": "admin.ui.restaurant",
  "Restaurant / Merchant": "admin.ui.restaurant_merchant",
  "Restaurant Addon Configuration": "admin.ui.restaurant_addon_configuration",
  "Restaurant analytics + order reports": "admin.ui.restaurant_analytics_order_reports",
  "Restaurant Catalog": "admin.ui.restaurant_catalog",
  "Restaurant Master": "admin.ui.restaurant_master",
  "Restaurant Name": "admin.ui.restaurant_name",
  "Restaurant Onboarding + FSSAI": "admin.ui.restaurant_onboarding_fssai",
  "Restaurant onboarding + FSSAI verification": "admin.ui.restaurant_onboarding_fssai_verification",
  "Restaurant Profile": "admin.ui.restaurant_profile",
  "Restaurant promo codes for your food store": "admin.ui.restaurant_promo_codes_for_your_food_store",
  "Restaurant Type": "admin.ui.restaurant_type",
  "Restaurants": "admin.ui.restaurants",
  "Retry": "admin.ui.retry",
  "Return date": "admin.ui.return_date",
  "Revenue": "admin.ui.revenue",
  "Revenue mix": "admin.ui.revenue_mix",
  "Revenue Model": "admin.ui.revenue_model",
  "Revenue trend (30 days)": "admin.ui.revenue_trend_30_days",
  "Revenue Updated": "admin.ui.revenue_updated",
  "Review (optional)": "admin.ui.review_optional",
  "Review earnings & settlements": "admin.ui.review_earnings_settlements",
  "Review partner": "admin.ui.review_partner",
  "Review uploaded partner documents and approve onboarding — configure document groups when needed.": "admin.ui.review_uploaded_partner_documents_and_approve_onboarding_configure_document_grou",
  "Reviews": "admin.ui.reviews",
  "Ride #": "admin.ui.ride",
  "Ride Attribute": "admin.ui.ride_attribute",
  "Ride booked": "admin.ui.ride_booked",
  "Ride Category wizard is replaced by dynamic sub-service flow": "admin.ui.ride_category_wizard_is_replaced_by_dynamic_sub_service_flow",
  "Ride completed": "admin.ui.ride_completed",
  "Ride discount (%)": "admin.ui.ride_discount",
  "Ride Images": "admin.ui.ride_images",
  "Ride Later": "admin.ui.ride_later",
  "RIDE LATER Pricing": "admin.ui.ride_later_pricing",
  "Ride No.": "admin.ui.ride_no",
  "Ride Now": "admin.ui.ride_now",
  "RIDE NOW Pricing": "admin.ui.ride_now_pricing",
  "Ride Overage ₹": "admin.ui.ride_overage",
  "Ride Summary": "admin.ui.ride_summary",
  "Ride Tags": "admin.ui.ride_tags",
  "Riders": "admin.ui.riders",
  "Rides": "admin.ui.rides",
  "Rides Dashboard": "admin.ui.rides_dashboard",
  "Rides Included": "admin.ui.rides_included",
  "Rides Operations": "admin.ui.rides_operations",
  "Role": "admin.ui.role",
  "Role Name": "admin.ui.role_name",
  "Role-specific metrics and activity": "admin.ui.role_specific_metrics_and_activity",
  "Roles & Privileges": "admin.ui.roles_privileges",
  "Round Trip": "admin.ui.round_trip",
  "Route Group": "admin.ui.route_group",
  "Rule": "admin.ui.rule",
  "Rules": "admin.ui.rules",
  "Run live operations": "admin.ui.run_live_operations",
  "Run Reports": "admin.ui.run_reports",
  "Running": "admin.ui.running",
  "S.No": "admin.ui.s_no",
  "SaaS tiers for tenants — pricing, limits, default modules, and plan highlights.": "admin.ui.saas_tiers_for_tenants_pricing_limits_default_modules_and_plan_highlights",
  "Sandbox Mode": "admin.ui.sandbox_mode",
  "Saturday": "admin.ui.saturday",
  "Save": "admin.ui.save",
  "Schedule": "admin.ui.schedule",
  "Schedule templates and image masters": "admin.ui.schedule_templates_and_image_masters",
  "Scheduled": "admin.ui.scheduled",
  "Scheduled At": "admin.ui.scheduled_at",
  "Scheduled At (for Ride Later)": "admin.ui.scheduled_at_for_ride_later",
  "Scheduled food orders": "admin.ui.scheduled_food_orders",
  "Scheduled Food Orders": "admin.ui.scheduled_food_orders_2",
  "Scheduled For": "admin.ui.scheduled_for",
  "Scheduled Orders": "admin.ui.scheduled_orders",
  "Scheduled Time": "admin.ui.scheduled_time",
  "Schedules and service images": "admin.ui.schedules_and_service_images",
  "Scope": "admin.ui.scope",
  "Search": "admin.ui.search",
  "Search address or transport hub (airport, station)": "admin.ui.search_address_or_transport_hub_airport_station",
  "Search by name or phone (min 3 chars)": "admin.ui.search_by_name_or_phone_min_3_chars",
  "Search company, slug, domain…": "admin.ui.search_company_slug_domain",
  "Search customer": "admin.ui.search_customer",
  "Search customer (min 3 chars)": "admin.ui.search_customer_min_3_chars",
  "Search driver": "admin.ui.search_driver",
  "Search drivers…": "admin.ui.search_drivers",
  "Search location": "admin.ui.search_location",
  "Search name, email, or phone…": "admin.ui.search_name_email_or_phone",
  "Search name, email, phone…": "admin.ui.search_name_email_phone",
  "Search privilege": "admin.ui.search_privilege",
  "Search records…": "admin.ui.search_records",
  "Search ref, customer, phone, address…": "admin.ui.search_ref_customer_phone_address",
  "Search services…": "admin.ui.search_services",
  "Search zones": "admin.ui.search_zones",
  "Search zones by name or code…": "admin.ui.search_zones_by_name_or_code",
  "Search zones...": "admin.ui.search_zones_2",
  "Search zones…": "admin.ui.search_zones_3",
  "Search…": "admin.ui.search_2",
  "Searching": "admin.ui.searching",
  "Secondary color": "admin.ui.secondary_color",
  "Secondary Color": "admin.ui.secondary_color_2",
  "Secret Key": "admin.ui.secret_key",
  "Security": "admin.ui.security",
  "Select a zone — configure pricing per vehicle and trip type (One Way / Round Trip).": "admin.ui.select_a_zone_configure_pricing_per_vehicle_and_trip_type_one_way_round_trip",
  "Select a zone to configure outstation KM slabs and per-vehicle pricing.": "admin.ui.select_a_zone_to_configure_outstation_km_slabs_and_per_vehicle_pricing",
  "Select a zone to manage hour/km rental packages — same flow as Caby rental master.": "admin.ui.select_a_zone_to_manage_hour_km_rental_packages_same_flow_as_caby_rental_master",
  "Select a zone to manage rental packages — zone-first flow like Caby rental master.": "admin.ui.select_a_zone_to_manage_rental_packages_zone_first_flow_like_caby_rental_master",
  "Select item to add...": "admin.ui.select_item_to_add",
  "Select language": "admin.ui.select_language",
  "Select languages…": "admin.ui.select_languages",
  "Select package": "admin.ui.select_package",
  "Select roles for dashboard access…": "admin.ui.select_roles_for_dashboard_access",
  "Select vehicle": "admin.ui.select_vehicle",
  "Send welcome notification (when configured)": "admin.ui.send_welcome_notification_when_configured",
  "Sent": "admin.ui.sent",
  "Separate Modules (not in Food Add)": "admin.ui.separate_modules_not_in_food_add",
  "Service": "admin.ui.service",
  "Service (optional)": "admin.ui.service_optional",
  "Service / Vehicle": "admin.ui.service_vehicle",
  "Service Catalog": "admin.ui.service_catalog",
  "Service Categories": "admin.ui.service_categories",
  "Service categories, skills, and visit pricing.": "admin.ui.service_categories_skills_and_visit_pricing",
  "Service Code": "admin.ui.service_code",
  "Service configuration (enable / disable)": "admin.ui.service_configuration_enable_disable",
  "Service Engine": "admin.ui.service_engine",
  "Service hub": "admin.ui.service_hub",
  "Service Hub": "admin.ui.service_hub_2",
  "Service hub and operating zone for this user": "admin.ui.service_hub_and_operating_zone_for_this_user",
  "Service hubs": "admin.ui.service_hubs",
  "Service hubs — transport, delivery, on-demand": "admin.ui.service_hubs_transport_delivery_on_demand",
  "Service Masters Guide": "admin.ui.service_masters_guide",
  "Service Module": "admin.ui.service_module",
  "Service Name": "admin.ui.service_name",
  "Service Name (English)": "admin.ui.service_name_english",
  "Service Provider": "admin.ui.service_provider",
  "Service type": "admin.ui.service_type",
  "Service Type": "admin.ui.service_type_2",
  "Service volume vs completed": "admin.ui.service_volume_vs_completed",
  "Service-wise modules": "admin.ui.service_wise_modules",
  "Services": "admin.ui.services",
  "Serving size": "admin.ui.serving_size",
  "Session Durations": "admin.ui.session_durations",
  "Session Rate": "admin.ui.session_rate",
  "Set driver commission % on zone": "admin.ui.set_driver_commission_on_zone",
  "Set driver commission % per zone": "admin.ui.set_driver_commission_per_zone",
  "Set Drop": "admin.ui.set_drop",
  "Set fare matrix (base, per km, per min, surge)": "admin.ui.set_fare_matrix_base_per_km_per_min_surge",
  "Set Location": "admin.ui.set_location",
  "Set Pickup": "admin.ui.set_pickup",
  "Set Prep Time": "admin.ui.set_prep_time",
  "Set zone fare matrix (base, per km, surge)": "admin.ui.set_zone_fare_matrix_base_per_km_surge",
  "Setting Categories (comma-separated)": "admin.ui.setting_categories_comma_separated",
  "Settings": "admin.ui.settings",
  "Settlement": "admin.ui.settlement",
  "Settlements": "admin.ui.settlements",
  "Settlements (Commission)": "admin.ui.settlements_commission",
  "SGD — Singapore Dollar": "admin.ui.sgd_singapore_dollar",
  "Share by service": "admin.ui.share_by_service",
  "Shared rejection reasons, delivery modes, address fields": "admin.ui.shared_rejection_reasons_delivery_modes_address_fields",
  "Short Description": "admin.ui.short_description",
  "Show all steps": "admin.ui.show_all_steps",
  "Show during driver mobile registration": "admin.ui.show_during_driver_mobile_registration",
  "Show in tenant create/edit form": "admin.ui.show_in_tenant_create_edit_form",
  "Show inactive": "admin.ui.show_inactive",
  "Shown as chips when selecting this plan on the tenant form": "admin.ui.shown_as_chips_when_selecting_this_plan_on_the_tenant_form",
  "Shown to drivers during mobile registration": "admin.ui.shown_to_drivers_during_mobile_registration",
  "Sign in & tenant context": "admin.ui.sign_in_tenant_context",
  "Silver": "admin.ui.silver",
  "Singapore": "admin.ui.singapore",
  "Skills": "admin.ui.skills",
  "Slots, partner pricing, incentives, substitution": "admin.ui.slots_partner_pricing_incentives_substitution",
  "Slug": "admin.ui.slug",
  "Slug (optional)": "admin.ui.slug_optional",
  "Sodium (mg)": "admin.ui.sodium_mg",
  "Sort order": "admin.ui.sort_order",
  "Sort Order": "admin.ui.sort_order_2",
  "SOS / Escalate": "admin.ui.sos_escalate",
  "SOS Command Center": "admin.ui.sos_command_center",
  "SOS Emergency Alerts": "admin.ui.sos_emergency_alerts",
  "SOS emergency button": "admin.ui.sos_emergency_button",
  "Source": "admin.ui.source",
  "Special Instructions": "admin.ui.special_instructions",
  "Specializations": "admin.ui.specializations",
  "Specific services": "admin.ui.specific_services",
  "Stacked revenue — transport, food, and grocery": "admin.ui.stacked_revenue_transport_food_and_grocery",
  "Staff roles, department, and permissions": "admin.ui.staff_roles_department_and_permissions",
  "Start Date": "admin.ui.start_date",
  "Start Trip": "admin.ui.start_trip",
  "Started": "admin.ui.started",
  "Starts at": "admin.ui.starts_at",
  "Stat Card": "admin.ui.stat_card",
  "State": "admin.ui.state",
  "State / Region": "admin.ui.state_region",
  "State Required": "admin.ui.state_required",
  "Status": "admin.ui.status",
  "Stock": "admin.ui.stock",
  "Stock Alert Threshold": "admin.ui.stock_alert_threshold",
  "Stock Alerts": "admin.ui.stock_alerts",
  "Store": "admin.ui.store",
  "Store analytics + order reports": "admin.ui.store_analytics_order_reports",
  "Store Analytics + Reports": "admin.ui.store_analytics_reports",
  "Store Catalog": "admin.ui.store_catalog",
  "Store Logo": "admin.ui.store_logo",
  "Store Master": "admin.ui.store_master",
  "Store master, types, categories": "admin.ui.store_master_types_categories",
  "Store Name": "admin.ui.store_name",
  "Store Onboarding + Verification": "admin.ui.store_onboarding_verification",
  "Store pickup": "admin.ui.store_pickup",
  "Store Type *": "admin.ui.store_type",
  "Store Types": "admin.ui.store_types",
  "Stores": "admin.ui.stores",
  "Stores & Products": "admin.ui.stores_products",
  "Street Address": "admin.ui.street_address",
  "Stripe": "admin.ui.stripe",
  "Sub Categories": "admin.ui.sub_categories",
  "Sub Category": "admin.ui.sub_category",
  "Sub-Service": "admin.ui.sub_service",
  "Sub-Service Catalog": "admin.ui.sub_service_catalog",
  "Sub-services": "admin.ui.sub_services",
  "Sub-Services": "admin.ui.sub_services_2",
  "Sub-Services moved to Transport Hub": "admin.ui.sub_services_moved_to_transport_hub",
  "Sub-services within enabled platform modules": "admin.ui.sub_services_within_enabled_platform_modules",
  "Sub-services within enabled platform modules — taxi, delivery, etc.": "admin.ui.sub_services_within_enabled_platform_modules_taxi_delivery_etc",
  "Subdomain": "admin.ui.subdomain",
  "Subject": "admin.ui.subject",
  "Submit": "admin.ui.submit",
  "Submitted": "admin.ui.submitted",
  "Subscription": "admin.ui.subscription",
  "Subscription based": "admin.ui.subscription_based",
  "Subscription plan": "admin.ui.subscription_plan",
  "Subscription Plan": "admin.ui.subscription_plan_2",
  "Subscription plan management": "admin.ui.subscription_plan_management",
  "Subscription plans": "admin.ui.subscription_plans",
  "Subscription plans for drivers and delivery partners": "admin.ui.subscription_plans_for_drivers_and_delivery_partners",
  "Subscriptions": "admin.ui.subscriptions",
  "Substitution + cancellation policy": "admin.ui.substitution_cancellation_policy",
  "Substitution Rules": "admin.ui.substitution_rules",
  "Subtract (-)": "admin.ui.subtract",
  "Subtract (−)": "admin.ui.subtract_2",
  "Sugar (g)": "admin.ui.sugar_g",
  "Summary": "admin.ui.summary",
  "Sunday": "admin.ui.sunday",
  "Super Admin": "admin.ui.super_admin",
  "Supplier": "admin.ui.supplier",
  "Suppliers": "admin.ui.suppliers",
  "Support": "admin.ui.support",
  "Support Number": "admin.ui.support_number",
  "Supported languages": "admin.ui.supported_languages",
  "Surge": "admin.ui.surge",
  "Surge delivery fee (peak hours)": "admin.ui.surge_delivery_fee_peak_hours",
  "Surge enabled": "admin.ui.surge_enabled",
  "Suspend": "admin.ui.suspend",
  "Suspended": "admin.ui.suspended",
  "Swiggy-style restaurant profile — basic, business, compliance, timing, approval, and revenue model.": "admin.ui.swiggy_style_restaurant_profile_basic_business_compliance_timing_approval_and_re",
  "System": "admin.ui.system",
  "Takeaway": "admin.ui.takeaway",
  "Target": "admin.ui.target",
  "Target earnings (₹)": "admin.ui.target_earnings",
  "Target trips": "admin.ui.target_trips",
  "Tax Group": "admin.ui.tax_group",
  "Tax Groups": "admin.ui.tax_groups",
  "Tax Rules": "admin.ui.tax_rules",
  "Taxes": "admin.ui.taxes",
  "Taxi drivers": "admin.ui.taxi_drivers",
  "Taxi Drivers": "admin.ui.taxi_drivers_2",
  "Taxi rides, drivers, zones & masters": "admin.ui.taxi_rides_drivers_zones_masters",
  "Template": "admin.ui.template",
  "Templates": "admin.ui.templates",
  "Tenant context": "admin.ui.tenant_context",
  "Tenant Master": "admin.ui.tenant_master",
  "Tenant Services": "admin.ui.tenant_services",
  "Tenants": "admin.ui.tenants",
  "Theme Color": "admin.ui.theme_color",
  "This month": "admin.ui.this_month",
  "This Month": "admin.ui.this_month_2",
  "This week": "admin.ui.this_week",
  "This Week": "admin.ui.this_week_2",
  "Thumbnail Image": "admin.ui.thumbnail_image",
  "Thursday": "admin.ui.thursday",
  "Ticket #": "admin.ui.ticket",
  "Tier": "admin.ui.tier",
  "Timestamp": "admin.ui.timestamp",
  "Timezone": "admin.ui.timezone",
  "Timezones": "admin.ui.timezones",
  "Timing": "admin.ui.timing",
  "Title": "admin.ui.title",
  "Title (subject)": "admin.ui.title_subject",
  "To": "admin.ui.to",
  "To City": "admin.ui.to_city",
  "To Date": "admin.ui.to_date",
  "Today": "admin.ui.today",
  "Toggle password": "admin.ui.toggle_password",
  "Toll": "admin.ui.toll",
  "Total": "admin.ui.total",
  "Total Drivers": "admin.ui.total_drivers",
  "Total earnings": "admin.ui.total_earnings",
  "Total plans": "admin.ui.total_plans",
  "Total referred": "admin.ui.total_referred",
  "Total tenants": "admin.ui.total_tenants",
  "Trade License": "admin.ui.trade_license",
  "Transactions": "admin.ui.transactions",
  "Translator Master": "admin.ui.translator_master",
  "Transmission": "admin.ui.transmission",
  "Transport": "admin.ui.transport",
  "Transport — End-to-End Flow": "admin.ui.transport_end_to_end_flow",
  "Transport / taxi home carousel": "admin.ui.transport_taxi_home_carousel",
  "Transport and delivery revenue, volume, and performance": "admin.ui.transport_and_delivery_revenue_volume_and_performance",
  "Transport and delivery volume and revenue": "admin.ui.transport_and_delivery_volume_and_revenue",
  "Transport Home Banners": "admin.ui.transport_home_banners",
  "Transport Hub": "admin.ui.transport_hub",
  "Transport hubs (POI)": "admin.ui.transport_hubs_poi",
  "Transport masters": "admin.ui.transport_masters",
  "Transport Service": "admin.ui.transport_service",
  "Transport service masters": "admin.ui.transport_service_masters",
  "Transport Setup": "admin.ui.transport_setup",
  "Transport Sub-Services": "admin.ui.transport_sub_services",
  "Transportation": "admin.ui.transportation",
  "Trial": "admin.ui.trial",
  "Trial days": "admin.ui.trial_days",
  "Trial Days": "admin.ui.trial_days_2",
  "Trip": "admin.ui.trip",
  "Trip mode": "admin.ui.trip_mode",
  "Trip Mode": "admin.ui.trip_mode_2",
  "Trip target": "admin.ui.trip_target",
  "Trip Type": "admin.ui.trip_type",
  "Trip Type — OUTSTATION": "admin.ui.trip_type_outstation",
  "Trip Type — RENTAL": "admin.ui.trip_type_rental",
  "Trips": "admin.ui.trips",
  "Tuesday": "admin.ui.tuesday",
  "Twilio": "admin.ui.twilio",
  "Type": "admin.ui.type",
  "Type Key": "admin.ui.type_key",
  "Type name to search…": "admin.ui.type_name_to_search",
  "Types": "admin.ui.types",
  "Types, specializations, and session rules": "admin.ui.types_specializations_and_session_rules",
  "Unassigned": "admin.ui.unassigned",
  "Unified Dispatcher": "admin.ui.unified_dispatcher",
  "Unit": "admin.ui.unit",
  "United Arab Emirates": "admin.ui.united_arab_emirates",
  "United Kingdom": "admin.ui.united_kingdom",
  "United States": "admin.ui.united_states",
  "Unverified": "admin.ui.unverified",
  "Upcoming orders scheduled for later delivery": "admin.ui.upcoming_orders_scheduled_for_later_delivery",
  "Upcoming scheduled restaurant orders": "admin.ui.upcoming_scheduled_restaurant_orders",
  "Uploaded": "admin.ui.uploaded",
  "Usage": "admin.ui.usage",
  "Usage Limit": "admin.ui.usage_limit",
  "Usage Today": "admin.ui.usage_today",
  "USD — US Dollar": "admin.ui.usd_us_dollar",
  "Use Add Package to create hour/km bundles. Edit or Delete existing packages below.": "admin.ui.use_add_package_to_create_hour_km_bundles_edit_or_delete_existing_packages_below",
  "Use availability schedule": "admin.ui.use_availability_schedule",
  "Use custom availability schedule": "admin.ui.use_custom_availability_schedule",
  "Use my current location": "admin.ui.use_my_current_location",
  "Used": "admin.ui.used",
  "Used for product_images master lookup": "admin.ui.used_for_product_images_master_lookup",
  "User": "admin.ui.user",
  "User growth (30 days)": "admin.ui.user_growth_30_days",
  "User ID": "admin.ui.user_id",
  "User management (customers + partners)": "admin.ui.user_management_customers_partners",
  "User type": "admin.ui.user_type",
  "User Type": "admin.ui.user_type_2",
  "Users": "admin.ui.users",
  "Users & Admins": "admin.ui.users_admins",
  "Utilization": "admin.ui.utilization",
  "Valid until": "admin.ui.valid_until",
  "Validity (days)": "admin.ui.validity_days",
  "Value": "admin.ui.value",
  "Variables (comma-separated)": "admin.ui.variables_comma_separated",
  "Variant": "admin.ui.variant",
  "Variant Name": "admin.ui.variant_name",
  "Variant Templates": "admin.ui.variant_templates",
  "Variants": "admin.ui.variants",
  "Veg": "admin.ui.veg",
  "Vehicle": "admin.ui.vehicle",
  "Vehicle Brand": "admin.ui.vehicle_brand",
  "Vehicle Color": "admin.ui.vehicle_color",
  "Vehicle Documents": "admin.ui.vehicle_documents",
  "Vehicle fleet hierarchy": "admin.ui.vehicle_fleet_hierarchy",
  "Vehicle Fleet Masters": "admin.ui.vehicle_fleet_masters",
  "Vehicle Model": "admin.ui.vehicle_model",
  "Vehicle Name": "admin.ui.vehicle_name",
  "Vehicle Number": "admin.ui.vehicle_number",
  "Vehicle type": "admin.ui.vehicle_type",
  "Vehicle Type": "admin.ui.vehicle_type_2",
  "Vehicle Types": "admin.ui.vehicle_types",
  "Vehicle types with OUTSTATION service type": "admin.ui.vehicle_types_with_outstation_service_type",
  "Vehicle types with RENTAL service type": "admin.ui.vehicle_types_with_rental_service_type",
  "Vehicle Variant": "admin.ui.vehicle_variant",
  "Vendor": "admin.ui.vendor",
  "Vendor App": "admin.ui.vendor_app",
  "Vendor Hub": "admin.ui.vendor_hub",
  "Venue": "admin.ui.venue",
  "Venues": "admin.ui.venues",
  "Venues, organizers, and cancellation policies.": "admin.ui.venues_organizers_and_cancellation_policies",
  "Verification Status": "admin.ui.verification_status",
  "Verified": "admin.ui.verified",
  "Verified account": "admin.ui.verified_account",
  "Verify uploaded documents and approve onboarding": "admin.ui.verify_uploaded_documents_and_approve_onboarding",
  "Video": "admin.ui.video",
  "Video Consultation Setup Guide": "admin.ui.video_consultation_setup_guide",
  "View": "admin.ui.view",
  "View document": "admin.ui.view_document",
  "View documents": "admin.ui.view_documents",
  "View Drivers": "admin.ui.view_drivers",
  "View Menu": "admin.ui.view_menu",
  "View packages": "admin.ui.view_packages",
  "View Products": "admin.ui.view_products",
  "View service": "admin.ui.view_service",
  "View Sub-Service List": "admin.ui.view_sub_service_list",
  "View subscribed partners": "admin.ui.view_subscribed_partners",
  "View, approve, and manage transport drivers — online status, trips, and documents.": "admin.ui.view_approve_and_manage_transport_drivers_online_status_trips_and_documents",
  "Visit Charges": "admin.ui.visit_charges",
  "Volume and completion by service": "admin.ui.volume_and_completion_by_service",
  "Waiting Charge / min": "admin.ui.waiting_charge_min",
  "Waive per-ride commission while active": "admin.ui.waive_per_ride_commission_while_active",
  "Wallet": "admin.ui.wallet",
  "Wallet + direct bank settlement": "admin.ui.wallet_direct_bank_settlement",
  "Wallet Balance": "admin.ui.wallet_balance",
  "Wallet top-up": "admin.ui.wallet_top_up",
  "Warehouse": "admin.ui.warehouse",
  "Warehouse + supplier masters": "admin.ui.warehouse_supplier_masters",
  "Warehouses": "admin.ui.warehouses",
  "Webhook Secret": "admin.ui.webhook_secret",
  "Wednesday": "admin.ui.wednesday",
  "Weekly": "admin.ui.weekly",
  "Weekly Holiday": "admin.ui.weekly_holiday",
  "Weight Type": "admin.ui.weight_type",
  "Weight Types": "admin.ui.weight_types",
  "What each service tab shows and key actions. Click a row to open that tab.": "admin.ui.what_each_service_tab_shows_and_key_actions_click_a_row_to_open_that_tab",
  "What this plan is for — shown when creating a tenant": "admin.ui.what_this_plan_is_for_shown_when_creating_a_tenant",
  "When outstation bookings are accepted": "admin.ui.when_outstation_bookings_are_accepted",
  "Window expired": "admin.ui.window_expired",
  "Workflows & dynamic forms": "admin.ui.workflows_dynamic_forms",
  "Working Calendars": "admin.ui.working_calendars",
  "Working Hours": "admin.ui.working_hours",
  "Yearly": "admin.ui.yearly",
  "Yesterday": "admin.ui.yesterday",
  "You": "admin.ui.you",
  "Your promos": "admin.ui.your_promos",
  "Zone": "admin.ui.zone",
  "Zone & Hub": "admin.ui.zone_hub",
  "Zone code": "admin.ui.zone_code",
  "Zone Commission": "admin.ui.zone_commission",
  "Zone commission % deducted": "admin.ui.zone_commission_deducted",
  "Zone detected at pickup": "admin.ui.zone_detected_at_pickup",
  "Zone Earnings": "admin.ui.zone_earnings",
  "Zone Fare Quote": "admin.ui.zone_fare_quote",
  "Zone level": "admin.ui.zone_level",
  "Zone Management": "admin.ui.zone_management",
  "Zone Management (external)": "admin.ui.zone_management_external",
  "Zone name": "admin.ui.zone_name",
  "Zone polygons, customer fee, partner earnings, incentives": "admin.ui.zone_polygons_customer_fee_partner_earnings_incentives",
  "Zone Pricing": "admin.ui.zone_pricing",
  "Zone setup with polygon + fare matrix": "admin.ui.zone_setup_with_polygon_fare_matrix",
  "Zone-based calculation": "admin.ui.zone_based_calculation",
  "Zone-Based Driver Earnings": "admin.ui.zone_based_driver_earnings",
  "Zone-wise scope": "admin.ui.zone_wise_scope",
  "Zones": "admin.ui.zones",
  "Zones & Coverage": "admin.ui.zones_coverage",
  "Zones & Partner Pricing": "admin.ui.zones_partner_pricing",
  "Zones & pricing (view / edit if permitted)": "admin.ui.zones_pricing_view_edit_if_permitted",
  "Zones + Fare Matrix": "admin.ui.zones_fare_matrix",
  "Zones + Partner Pricing": "admin.ui.zones_partner_pricing_2",
  "Zones + Partner Pricing + Incentives": "admin.ui.zones_partner_pricing_incentives",
  "Zones + partner pricing + incentives → grocery masters → Grocery Add → slots & dispatch.": "admin.ui.zones_partner_pricing_incentives_grocery_masters_grocery_add_slots_dispatch"
};
